import './table.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Link } from 'react-router';
import moment from 'moment';
import noop from 'lodash/noop';

const Table = ({
	table,
	intl,
	sortByColumn,
	remove,
	can
}) => (
	<div className="table-container table-container--projector contest-rule-list-table">
		<div className="table-container--projector__body">
			<div className="table-container--projector__body-content">
				<table className="simple-table simple-table--static contest-table">
					<thead className="simple-table__head font-roboto-medium">
						<tr>
							{ table.headers.map((header, i) => (
								<th
									key={i}
									className={cn({
										'sort-header': header.direction,
										'active': table.sortedColumn.index === header.index,
										[header.className]: header.className,
										[table.sortedColumn.direction]: (
											table.sortedColumn.index === header.index && table.sortedColumn.direction
										)
									})}
									onClick={() => header.direction ? sortByColumn(header.index) : noop}>{intl(header.title)}</th>
							))}
						</tr>
					</thead>

					<tbody className="simple-table__body">
						{ table.rows.map((row, i) => (
							<tr key={i}>
								<td className="id"><span>{ row.id }</span></td>
								<td><span>{ row.name }</span></td>
								<td><span>{ moment(row.starts_at).format('YYYY-MM-DD HH:mm') }</span></td>
								<td><span>{ moment(row.ends_at).format('YYYY-MM-DD HH:mm') }</span></td>
								<td className="config"><span>{ JSON.stringify(row.config)}</span></td>
								<td className="actions">
									{ can('contestEdit') && (
										<Link to={`contests/edit/${row.id}`} className="action_edit" />
									) }

									{ can('contestEdit') && (
										<a
											href="#"
											onClick={e => {
												e.preventDefault();
												confirm(`${intl('Remove contest?')}`) && remove(row.id);
											}} className="action_delete" />

									) }
								</td>
							</tr>
						)) }
					</tbody>
				</table>
			</div>
		</div>
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	remove: PropTypes.func,
	can: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/contests/components/table.js